import { render } from "./NotaDiaria.vue?vue&type=template&id=ba57cb8e"
import script from "./NotaDiaria.vue?vue&type=script&lang=js"
export * from "./NotaDiaria.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ProjetosCodes\\Ideias\\front\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__